angular
  .module('inkfinder')
  .factory('_', function($window) {
    return $window._;
  })
  // App version numbers
  .constant('APP_VERSION', '0.9.7')
  .constant('AUTH_EVENTS', {
    loginSuccess: 'auth-login-success',
    loginFailed: 'auth-login-failed',
    logoutSuccess: 'auth-logout-success',
    sessionTimeout: 'auth-session-timeout',
    notAuthenticated: 'auth-not-authenticated',
    notAuthorized: 'auth-not-authorized',
    notFound: 'server-not-found',
    collectorUpdated: 'collector-session-updated'
  })
  // UI messages for switching modes
  .constant('SWITCH_MESSAGE', {
    buying: 'Switch to selling',
    selling: 'Switch to buying'
  })
  // User role names, descriptions, and action messages
  .constant('USER_ROLES', {
    collector: 'collector',
    operator: 'operator',
    artist: 'artist'
  })
  // Reserved routes
  .constant('RESERVED_ROUTES', [
    'login',
    'dashboard',
    'appointment',
    'appointments',
    'artist',
    'artists',
    'client',
    'clients',
    'profile',
    'invitation',
    'project',
    'projects',
    'reset-password',
    'shop',
    'shops',
    'signup',
    'messages',
    'request-appt'
  ])
  // Appointment preferred time
  .constant('PREFERRED_TIME', {
    morning: {
      id: 1,
      description: 'Morning'
    },
    afternoon: {
      id: 2,
      description: 'Afternoon'
    },
    evening: {
      id: 3,
      description: 'Evening'
    }
  })
  .constant('RESPONSE_MESSAGES', {
    authorizationError: {
      message: 'Sorry. You can’t view that screen.',
      code: 1
    },
    authenticationError: {
      message: 'Damn. You need to sign in.',
      code: 2
    },
    serverError: {
      message: 'We can’t access the server right now. Try logging in again.',
      code: 3
    },
    emailNotificationSent: {
      message: 'We sent out an email notification.',
      code: 4
    },
    emailNotificationFailed: {
      message: 'We tried to send an email notification, but it failed.',
      code: 5
    },
    paymentUpdateError: {
      message: 'There was a problem updating the price.',
      code: 6
    },
    notFoundError: {
      message: 'We couldn’t find what you were looking for.',
      code: 7
    },
    closedWithoutSaving: {
      message:
        'Just a heads up...You closed the window without saving any changes.',
      code: 8
    },
    saved: {
      message: 'Your changes were saved.',
      code: 9
    },
    artistNotScheduled: {
      message: `This artist is not scheduled at the time you selected. You can still save
    this appointment, though.`,
      code: 10
    },
    existingAppointment: {
      message: `There is an existing appointment during this time. This appointment can’t
    be saved.`,
      code: 11
    },
    outsideShopHours: {
      message: `This time is outside of shop hours. This appointment can't be saved.`,
      code: 11
    },
    sameAppointmentTime: {
      message: `This is the same time block as the original appointment.`,
      code: 12
    },
    projectUpdateConfirmedAppt: {
      message: `You have a confirmed appointment for this project. Making changes may
    require your appointment to change.`,
      code: 13
    },
    archived: {
      message: 'This appointment has been archived.',
      code: 14
    }
  })
  // Default state names for each role
  .constant('DEFAULT_STATES', {
    public: 'login',
    buying: 'inkfinder.projects',
    selling: 'inkfinder.dashboard',
    operator: 'inkfinder.dashboard',
    artist: 'inkfinder.dashboard'
  })
  // Intercom app ID
  .constant('INTERCOM_APPID', 'mbl97ptq')
  .constant('STATUS', {
    all: 'All types of',
    requested: 'Requested',
    requestDeclined: 'Request declined',
    expired: 'Expired',
    unconfirmed: 'Unconfirmed',
    confirmed: 'Confirmed',
    declined: 'Declined',
    completed: 'Completed',
    collectorCancelled: 'Collector cancelled',
    artistCancelled: 'Artist cancelled',
    archived: 'Archived'
  })
  .constant('STATUS_IDS', {
    requested: 10,
    requestDeclined: 20,
    expired: 30,
    unconfirmed: 40,
    confirmed: 50,
    declined: 60,
    completed: 70,
    collectorCancelled: 80,
    artistCancelled: 90,
    archived: 100
  })
  .constant('PAYMENT_STATUS_IDS', {
    approved: 1,
    void: 2,
    refund: 3,
    declined: 4
  })
  .constant('SORTOPTIONS', {
    appointmentDatetime: 'Appointment date',
    collectorLastName: 'Client last name'
  })
  // Email notification codes
  .constant('NOTIFICATIONS', {
    // "Welcome to Ink Finder"/Generic welcome email when a collector creates an
    // Ink Finder account.
    collectorWelcome: 1,

    // "Project created."/Email sent for collectors when an artist or operator
    // creates a project for them on their behalf.
    projectCreated: 2,

    // "<Artist name> at <Shop name> sent you an estimate"/Email sent when an
    // estimate is created/sent to a collector
    collectorEstimate: 3,

    // "<Shop name> invited you to join their shop as an operator"/Email sent when
    // an operator is invited to a shop roster
    operatorInvite: 4,

    // "<Shop name> invited you to join their artist roster"/Email sent when an
    // artist is invited to a shop roster
    artistInvite: 5,

    // "<Artist name> accepted your invitation to join your artist roster/Email
    // sent when an artist confirms an invitation
    artistAccept: 6,

    // "<Operator name> accepted your invitation to join your shop roster/Email
    // sent when an operator confirms an invitation
    operatorAccept: 7,

    // "The artist daily"/Email sent for artist daily stats and appointments
    artistDaily: 8,

    // "The shop daily"/Email sent for operators daily shop stats and appointments
    operatorDaily: 9,

    // "Merge accounts"/Email sent for collectors to merge their Ink Finder
    // account with their Facebook account. This merge adds a Facebook ID to a
    // collector account.
    facebookMerge: 10,

    // "Password reset."/Email sent for collectors to reset their password after
    // they request a reset. The link in the email confirms the token on the API
    // and allows them to choose and save a new password on their Ink Finder
    // account.
    passwordReset: 11,

    // Appointment update /Email sent to collectos when their appointment
    // information has been updated by an artist or operator.
    appointmentUpdate: 12,

    // Appointment confirmation by collector /Email sent to all confirmed
    // operators at a shop to notify them when a collector confirs an appointment
    appointmentConfirmedByCollector: 13,

    // Appointment declined by collector /Email sent to all confirmed operators at
    // a shop to notify them when a collector declines an appointment
    appointmentDeclinedByCollector: 14,

    // Appointment confirmation by operator/artist /Email sent to the collector to
    // notify them when an artist or operator confirms their appointment
    appointmentConfirmedByOperatorOrArtist: 15,

    // 16 Email sent to a collector when an appointment is upcoming

    // Appointment completed by operator/artist /Email sent to the collector to
    // notify them when an artist or operator completes their appointment
    appointmentCompleteToCollector: 17,

    // Appointment completed by operator/artist /Email sent to the artist to
    // notify them when an operator completes one of their appointment
    appointmentCompleteToArtist: 18,

    // Appointment update /Email sent to artists when their appointment
    // information has been updated by an operator.
    artistAppointmentUpdate: 19,

    // "<Operator name> at <Shop name> sent an estimate for your appointment"
    // Email sent to artists when an estimate is created/sent to a collector by an
    // operator
    artistEstimate: 20,

    // "<Operator name> at <Shop name> confirmed your appointment"/Email sent to
    // artists when an appointment is confirmed by an operator
    artistConfirmed: 21,

    // "<Operator name> at <Shop name> updated a project you're working on" Email
    // sent to artist/shop operators when an project is updated
    projectUpdated: 22,

    // 23 is for appointment message nofication

    // Email sent to collectors to confirm their email address
    emailConfirmation: 24,

    // Email sent to artists, operators, and collectors when an appointment is
    // marked to be rescheduled later.
    appointmentReschedule: 25,

    // Email sent to artists, operators, and collectors when an appointment is
    // cancelled.
    appointmentCancellation: 26

    // 27 Email sent to the collector to notify them about the 14-day or the
    // 30-day followup message
  })
  .constant('BASE', {
    path: 'templates/src/' // Refactor this to point to shared template assets
  })
  // Google maps key
  .constant('GMAPS_KEY', 'AIzaSyA7T4K49Snq8GL5v1XIrYn2ZInsnty7H-c');



// WEBPACK FOOTER //
// ./constants/constants.js